export default [
	{	path: "/settings/workflows",
		component: () => import("../views/Settings/Workflows/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{	path: "/settings/workflows/edit/:id?",
		component: () => import("../views/Settings/Workflows/Edit.vue"),
	},
	{	path: "/settings/workflows/:workflowId/stages/:id?",
		component: () => import("../views/Settings/Workflows/Stage.vue"),
	},
	{
		path: "/workflows/:workflowId",
		component: () => import("../views/Workflows/ViewWorkflow.vue"),
	},
	{
		path: "/workflows/:workflowId/stages/:stageId",
		component: () => import("../views/Workflows/Stages/ViewStage.vue"),
	}
]
